// QueryStatusFilter.js
import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography
} from '@mui/material';

const QueryStatusFilter = ({ 
  value = 'all', 
  onChange, 
  size = 'small', 
  fullWidth = true,
  label = 'Status',
  variant = 'outlined',
  options = null
}) => {
  // Use provided options or fallback to default
  const statusOptions = options && options.length > 0 ? 
    [
      { value: 'all', label: 'All Status' },
      ...options
    ] : [
      { value: 'all', label: 'All Status' }
    ];

  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <FormControl size={size} fullWidth={fullWidth} variant={variant}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        label={label}
      >
        {statusOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Typography variant="body2">
              {option.label}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default QueryStatusFilter; 